import * as yup from 'yup';
import { alphabetRegix, numericDashRegix } from '../utils/functions';

export const individual_international_tax_self_certification_validation_schema = yup.object().shape({

  socialSecurityNumber1: yup
    .string().matches(numericDashRegix, 'only_numbers_and_dashes_allowed'),

  individualTaxpayerIdentificationNumber1: yup
    .string()
    .matches(numericDashRegix, 'only_numbers_and_dashes_allowed'),

  aTaxpayerIdentificationNumber1: yup
    .string()
    .matches(numericDashRegix, 'only_numbers_and_dashes_allowed'),

  citizenshipCountries: yup
    .array()
    .when('areYouAUSPerson', {
      is: '1',
      then: schema =>
        schema
          .required('citizenship_countries_is_requires')
          .min(1, 'citizenship_country_select_atleast_one'),
      otherwise: schema => schema.notRequired(),
    }),

  // visaJurisdictionCountryName1: yup
  //   .string()
  //   .when('doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia', {
  //     is: '1',
  //     then: schema => schema.required('this_field_is_required'),
  //     otherwise: schema => schema.notRequired(),
  //   }),

  // pleaseIndicateTheStatusOfEachPermanentResidencyId1: yup
  //   .object()
  //   .when('doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia', {
  //     is: '1',
  //     then: schema => schema.required('this_field_is_required'),
  //     otherwise: schema => schema.notRequired(),
  //   }),
  visaResident: yup.array().when(
    'doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia',
    (value, schema) => {
      if (value?.toString() === '1') {
        return schema.of(
          yup.object().shape({

            taxImmigrantJurisdiction_Section_Show: yup.boolean(),

            country: yup.string().when(
              'taxImmigrantJurisdiction_Section_Show',
              {
                is: true,
                then: (s) =>
                  s.required('this_field_is_required')
                    .matches(alphabetRegix, 'this_field_is_required'),
                otherwise: (s) => s.notRequired(),
              }
            ),

            residencyStatus: yup.mixed().when(
              'taxImmigrantJurisdiction_Section_Show',
              {
                is: true,
                then: (s) =>
                  s.required('please_select_an_option'),
                otherwise: (s) => s.notRequired(),
              }
            ),
          })
        ).test(
          'at-least-one',
          'visa_information_required',
          function (value) {
            if (!value) return false;

            const visible = value.filter(
              (v) => v.taxImmigrantJurisdiction_Section_Show
            );

            if (visible.length === 0) return false;

            return visible.every(
              (v) => v.country && v.residencyStatus
            );
          }
        );
      }
      return schema.notRequired();
    }
  ),

  taxResident: yup.array().when(
    'areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia',
    (value, schema) => {
      if (value?.toString() === '1') {
        return schema.of(
          yup.object().shape({
            taxResidentJurisdiction_Section_Show: yup.boolean(),

            country: yup.mixed().when('taxResidentJurisdiction_Section_Show', {
              is: true,
              then: () => yup.mixed().required('country_is_required'),
              otherwise: () => yup.mixed().nullable(),
            }),

            tin: yup
              .string()
              .nullable()
              .when('taxResidentJurisdiction_Section_Show', {
                is: true,
                then: () =>
                  yup
                    .string()
                    .nullable()
                    .matches(numericDashRegix, 'only_numbers_and_dashes_allowed')
                    .test('tin-or-reason', 'this_field_is_required', function (value) {
                      const { tinJurisdictionStatus } = this.parent;
                      const isTinEmpty = !value || value.trim() === '';
                      const isReasonEmpty =
                        !Array.isArray(tinJurisdictionStatus) ||
                        tinJurisdictionStatus.length === 0;

                      if (isTinEmpty && isReasonEmpty) return false;
                      return true;
                    }),
                otherwise: () => yup.string().nullable(),
              }),

            tinJurisdictionStatus: yup
              .array()
              .when('taxResidentJurisdiction_Section_Show', {
                is: true,
                then: () =>
                  yup.array().test(
                    'reason-or-tin',
                    'select_atleast_one',
                    function (value) {
                      const { tin } = this.parent;
                      const isTinFilled = tin && tin.trim() !== '';

                      if (isTinFilled) return true;
                      const isReasonEmpty =
                        !Array.isArray(value) || value.length === 0;

                      if (isReasonEmpty) return false;
                      return true;
                    }
                  ),
                otherwise: () => yup.array().nullable(),
              }),

            tinOther: yup
              .string()
              .nullable()
              .test('tinOther-required', 'this_field_is_required', function (value) {
                const { taxResidentJurisdiction_Section_Show, tinJurisdictionStatus } =
                  this.parent;

                if (!taxResidentJurisdiction_Section_Show) return true;

                const has797 =
                  Array.isArray(tinJurisdictionStatus) &&
                  tinJurisdictionStatus.some((i) => String(i.valueId) === '797');

                if (has797 && (!value || value.trim() === '')) return false;
                return true;
              }),
          })
        );
      }

      return schema.notRequired();
    }
  ),
  iUnderstandAndAgreeToTheDeclarationAndSignature: yup
    .boolean()
    .oneOf([true], 'must_agree_declaration_signature'),
}).test(
  'at-least-one-tax-id',
  'at_least_one_tax_id_required',
  function (values) {
    if (values?.areYouAUSPerson !== '1') {
      return true;
    }

    const hasValue =
      values?.socialSecurityNumber1 ||
      values?.individualTaxpayerIdentificationNumber1 ||
      values?.aTaxpayerIdentificationNumber1;

    if (hasValue) return true;

    return this.createError({
      path: 'socialSecurityNumber1',
      message: 'at_least_one_tax_id_required',
    });
  }
);